'use client'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { IPageListItem } from '@/schemas/pages'
import { getPagesListService } from '@/services/domain/pages/PageService'
import { buildPageTree } from '@/services/domain/pages/PageTreeService'

const NO_PAGES: IPageListItem[] = []

/**
 * Páginas ativas do CMS para a central de ajuda, o menu lateral e a trilha. O React Query é o cache compartilhado entre
 * esses componentes (uma busca só por tela, válida por 10 minutos); a árvore é montada aqui a partir da lista.
 */
export function useHelpPages() {
    const query = useQuery({
        queryKey: ['pages-list'],
        queryFn: getPagesListService,
        staleTime: 1000 * 60 * 10,
        // O logout limpa o cache do React Query (clearAllStores): a lista pública já na tela fica enquanto rebusca.
        placeholderData: keepPreviousData,
    })

    const list = query.data ?? NO_PAGES
    const tree = useMemo(() => buildPageTree(list), [list])

    return { list, tree, isLoading: query.isLoading, isError: query.isError }
}
